import type { TMessages } from '@/types/TMessages'

export const messages = {
  comments: {
    main: 'Раздел "Кредиты и лизинг"',
    MFOPage: 'Поле Финанс',
    advancePaymentOnFutureHarvest: 'Авансирование',
    sberRassrochka: 'СБЕР Рассрочка',
    oborotSber: 'СБЕР Оборотный кредит',
    centerInvestLoan: 'Банк Центр-Инвест',
    investSber: 'СБЕР Инвестиционный кредит',
    sberLeasing: 'СБЕР Лизинг',
    interleasing: 'Интерлизинг',
    agriculturalMachinesAndEquipmentLeasing: 'Росагролизинг',
    fleetFinanceLeasing: 'Fleet Finance',
  },
} as const satisfies TMessages
